import type en from '../en/dashboard'
import type { Translation } from '../types'

/** The dashboard: the overview of all sites */
const dashboard: Translation<typeof en> = {
  "dashboard.greeting.morning": "Buenos días, {name}",
  "dashboard.greeting.afternoon": "Buenas tardes, {name}",
  "dashboard.greeting.evening": "Buenas noches, {name}",
  "dashboard.subtitle": "Resumen de la red en todos sus sitios",
  "dashboard.totalSites": "Total de sitios",
  "dashboard.acrossAllSites": "En todos los sitios",
  "dashboard.connectedNow": "Conectados ahora",
  "dashboard.activeAlerts": "Alertas activas",
  "dashboard.throughput": "Rendimiento de la red",
  "dashboard.averageOver": "promedio en {period}",
  "dashboard.download": "↓ Descarga",
  "dashboard.upload": "↑ Subida",
  "dashboard.allSitesNote": "Todos los sitios juntos. El historial de cada sitio está en su página.",
  "dashboard.recentAlerts": "Alertas recientes",
  "dashboard.allAlerts": "Todas las alertas",
  "dashboard.noAlerts": "No hay alertas activas — todos los sistemas funcionan bien",
  "dashboard.trafficSummary": "Resumen del tráfico",
  "dashboard.totalReceived": "Total recibido",
  "dashboard.totalSent": "Total enviado",
  "dashboard.slowestSite": "SITIO MÁS LENTO",
  "dashboard.avg": "{rate} de media",
}

export default dashboard
